export const APP_ROUTES = {
  home: "/",
  admin: "/admin",
  login: "/login",
  updateSchedule: "/update-schedule",
  contactUs: "/contact-us",
};

export const URLS = {
  availability: "jc-clinic/availability",
  analyticsUsers: "https://spd-election.onrender.com/analytics/users",
};

export const doctors = {
  jeyachandran: { name: "jeyachandran", order: 1, degree: "MBBS, MS" },
  rajasri: { name: "rajasri", order: 2, degree: "MBBS, MD" },
};

export const MENU_ITEM = {
  home: "home",
  updateSchedule: "updateSchedule",
  changeTheme: "changeTheme",
  language: "language",
  contactUs: "contactUs",
  logout: "logout",
};

export const lightTheme = {
  // palette values for light mode
  primary: { main: "#98302F" },
  secondary: { main: "#963d3d" },
  tertiary: { main: "#963d3d" },
};

export const darkTheme = {
  primary: { main: "#46ff46" },
  secondary: { main: "#1bc91b" },
  text: {
    primary: "#46ff46",
    // secondary: "#957370",
    // disabled: "#442c2e",
    // hint: "#442c2e",
  },
};
